import React from 'react';
import styled from 'styled-components';
import colors from '../styles/colors';

const DividerContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 2rem 0;
  gap: 1rem;
`;

const FlagLine = styled.div`
  height: 2px;
  flex: 1;
  background: linear-gradient(90deg, 
    ${colors.primary.green} 0%, 
    ${colors.primary.yellow} 50%, 
    ${colors.primary.blue} 100%
  );
  border-radius: 1px;
`;

const FlagIcon = styled.div`
  font-size: 1.5rem;
  display: flex;
  gap: 0.5rem;
`;

const FlagDivider = () => {
  return (
    <DividerContainer>
      <FlagLine />
      <FlagIcon>
        <span>🇧🇷</span>
        <span>🇮🇹</span>
      </FlagIcon>
      <FlagLine />
    </DividerContainer>
  );
};

export default FlagDivider;
